import { render, staticRenderFns } from "./BasesManagerForm.vue?vue&type=template&id=72fa2d9c&scoped=true&"
import script from "./BasesManagerForm.vue?vue&type=script&lang=ts&"
export * from "./BasesManagerForm.vue?vue&type=script&lang=ts&"
import style0 from "./BasesManagerForm.vue?vue&type=style&index=0&id=72fa2d9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fa2d9c",
  null
  
)

export default component.exports